import { createSelector } from "reselect";
import { selectors as requestSelectors } from "redux-request-state";

const leadDistributionBase = state => state.marketplace.integrations.leadIntegration.leadDistribution;
export const getLeadDistribution = requestSelectors.getData( leadDistributionBase );
export const isLoadingLeadDistribution = requestSelectors.isLoading( leadDistributionBase );

const leadSourcesBase = state => state.marketplace.integrations.leadIntegration.leadSources;
export const getLeadSources = createSelector( leadSourcesBase, leadSources => leadSources.data || [] );
export const isLoadingLeadSources = requestSelectors.isLoading( leadSourcesBase );